import React from 'react';
import { formatSectionTitle, getSectionIcon } from '../../../utils/formatters';
import ReportContent from './ReportContent';

const ReportSection = ({ section, index }) => {
  return (
    <div className="report-section" id={`section-${index}`}>
      <div className="section-header">
        <span className="section-icon">{getSectionIcon(section.section_type)}</span>
        <h2>{formatSectionTitle(section.section_type)}</h2>
      </div>
      <div className="section-content">
        <ReportContent content={section.content} />
      </div>
    </div>
  );
};

export default ReportSection;
